"use strict";

angular.module("core")
.service("NavBarToggleService", function($document, $timeout) {
    this.activateAutoCollapse = function() {
        // https://stackoverflow.com/a/23769601/1088152
        $document.click(function(event) {
            var clickOver = $(event.target);
            var _opened = $(".navbar-collapse").hasClass("in");
            if (_opened === true && !clickOver.hasClass("navbar-toggle")
                && !clickOver.parents(".navbar-collapse").length) {
                $("button.navbar-toggle").click();
            }

            $timeout(function() {
                if ($(".navbar-toggle").hasClass("collapsed") === true) {
                    $("#refresh-button").css("display", "none");
                } else {
                    $("#refresh-button").css("display", "block");
                }
            });
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/bootstrap-helper/nav-bar-toggle.service.js
// module id = 883
// module chunks = 0